import React from 'react';
import { Alert, Form, Icon, Input, Button } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import { resetPassword, loginTwoFactor } from '../../reducers/user/actions';
import {getUserToken} from "../../reducers/user/selectors";
import { resetPasswordConfirmUserRequest, resetPasswordConfirmRequest } from '../../api/requests';

import classes from './ResetSendForm.css';
import actLogo from "../../assets/img/act_quicr_logo.png";

const routes = require('../../routes.json');

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ResetSendForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      checkConfirmRequestError: 'Checking...',
      username: '',
    };
  }

  async componentDidMount() {
    if (this.props.token) {
      try {
        const { data } = await resetPasswordConfirmUserRequest({ token: this.props.token });
        this.setState({ checkConfirmRequestError: null, username: data.username });
      } catch (e) {
        this.setState({ checkConfirmRequestError: get(e, 'response.data.message') });
      }
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({ isLoading: true, errorMessage: null, responseMessage: null });

        try {
          await resetPasswordConfirmRequest({ password: get(values, 'password'), confirm_password: get(values, 'passwordConfirm'), token: this.props.token });
          this.setState({ responseMessage: 'Success' });
          setTimeout(() => {
            this.props.history.push(routes.admin.login);
          }, 1200);
        } catch (err) {
          this.setState({ errorMessage: get(err, 'response.data.msg'), isLoading: false});
        }
      }
    });
  };


  render() {
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
    const { isLoading, errorMessage, responseMessage, isSubmitted, checkConfirmRequestError, username } = this.state;

    const passwordError = (isFieldTouched('password') || isSubmitted) && getFieldError('password');
    const passwordConfirmError = (isFieldTouched('passwordConfirm') || isSubmitted) && getFieldError('passwordConfirm');

    return (
      <div className={classes.loginForm}>
        <Form onSubmit={this.handleSubmit}>
          <h2 className={classes.headline} style={{ color: 'rgb(40, 109, 168)' }}>
            <img alt="act" src={actLogo} style={{ objectFit: 'contain', width: '60px', height: 'auto' }} />
            Reset password
          </h2>
          {username && <p>For: <b>{username}</b></p>}

          {!checkConfirmRequestError && (<div>
            <Form.Item validateStatus={passwordError ? 'error' : ''} help={passwordError || ''}>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: 'Required' }]
              })(
                <Input type='password' prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Password" />,
              )}
            </Form.Item>
            <Form.Item validateStatus={passwordConfirmError ? 'error' : ''} help={passwordConfirmError || ''}>
              {getFieldDecorator('passwordConfirm', {
                rules: [{ required: true, message: 'Required' }]
              })(
                <Input type='password' prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Repeat password" />,
              )}
            </Form.Item>
          </div>)}

          {errorMessage && <Alert message={errorMessage} type="error" className={classes.alertsMb} />}
          {responseMessage && <Alert message={responseMessage} type="success" className={classes.alertsMb} />}
          {checkConfirmRequestError && <Alert message={checkConfirmRequestError} type="error" className={classes.alertsMb} />}

          {!responseMessage && !checkConfirmRequestError && (<Form.Item>
            <Button type="primary" size="large" htmlType="submit" disabled={hasErrors(getFieldsError())} className={classes.submitButton}>
              Reset password
              {isLoading && <Icon type="loading" />}
            </Button>
          </Form.Item>)}

          <p className={classes.paragraph}>To first step <Link to={routes.admin.resetPassword}>Click here</Link></p>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userToken: getUserToken(state),
});

const mapDispatchToProps = {
  resetPassword,
  loginTwoFactor,
};

export default Form.create({ name: 'login' })(connect(mapStateToProps, mapDispatchToProps)(ResetSendForm));



// WEBPACK FOOTER //
// ./src/components/ResetSendForm/ResetSendForm.js